import * as Yup from 'yup'
import { ChainProtocol } from '@archax/shared-types'

export function getDecimalValidator(schema: Yup.NumberSchema, protocol: ChainProtocol) {
  if (protocol === ChainProtocol.Stellar) {
    return schema
      .typeError('Please enter a valid number between 0 and 7.')
      .min(0, 'Please enter a valid number between 0 and 7.')
      .max(7, 'Please enter a valid number between 0 and 7.')
      .default(0)
      .required('Please enter a valid number between 0 and 7.')
  }

  return schema
    .typeError('Please enter a valid number between 0 and 19.')
    .min(0, 'Please enter a valid number between 0 and 19.')
    .max(19, 'Please enter a valid number between 0 and 19.')
    .default(0)
    .required('Please enter a valid number between 0 and 19.')
}
